import React from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import '../../../Assets/css/maurice_lacroixWatch.css'
import BannerImg from '../../../Assets/images/watches/maurice-lacroix-imgs/banner-desktop.jpg'
import BannerMobileImg from '../../../Assets/images/watches/maurice-lacroix-imgs/banner-mobile.png'

import Bannerbottom from '../../../Assets/images/watches/maurice-lacroix-imgs/banner-bottom.png'
import img1975 from '../../../Assets/images/watches/maurice-lacroix-imgs/img-1975.jpg'
import alkonic from '../../../Assets/images/watches/maurice-lacroix-imgs/alkonic.jpg'
import fiaba from '../../../Assets/images/watches/maurice-lacroix-imgs/fiaba.jpg'
import masterpiece from '../../../Assets/images/watches/maurice-lacroix-imgs/collection-img/masterpiece.png'
import alkonic1 from '../../../Assets/images/watches/maurice-lacroix-imgs/collection-img/alkonic.png'
import alkon from '../../../Assets/images/watches/maurice-lacroix-imgs/collection-img/alkon.png'
import Imgg1975 from '../../../Assets/images/watches/maurice-lacroix-imgs/collection-img/1975.png'
import pontos from '../../../Assets/images/watches/maurice-lacroix-imgs/collection-img/pontos.png'
import fiaba1 from '../../../Assets/images/watches/maurice-lacroix-imgs/collection-img/fiaba.png'
import manufacture1 from '../../../Assets/images/watches/maurice-lacroix-imgs/manufacture1.png'
import manufacture2 from '../../../Assets/images/watches/maurice-lacroix-imgs/manufacture2.png'
import Slider from "react-slick";
import { isMobile, isMobileOnly } from "react-device-detect";
import { useHistory } from "react-router-dom/cjs/react-router-dom";


const MauriceLacroix = () => {
    const history = useHistory();
    const featured = [
        { id: 1, title: "1975", img: img1975 },
        { id: 2, title: "ICONIC", img: alkonic },
        { id: 3, title: "FIABA", img: fiaba },
    ];


    const collections = [
        { id: 1, name: "MASTERPIECE", img: masterpiece },
        { id: 2, name: "ALKONIC", img: alkonic1 },
        { id: 3, name: "ALKON", img: alkon },
        { id: 4, name: "1975", img: Imgg1975 },
        { id: 5, name: "PONTOS", img: pontos },
        { id: 6, name: "FIABA", img: fiaba1 },
    ];

    var settingsWatch = {
        dots: false,
        infinite: false,
        autoplay: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 4,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                    autoplay: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }
        ]
    };
    var settingsWatchTop = {
        dots: false,
        infinite: false,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    autoplay: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };
    return (
        <div>
            <div className="maurice_lacroix_page_section">
                {/* Hero Banner */}
                <section className="hero-banner text-white">
                    <Container fluid >
                        <Row>
                            <Col sm={12} md={12} className="p-0">


                                {isMobileOnly ? <Image
                                    src={BannerMobileImg}
                                    alt="1975 Legacy Watch"
                                    fluid
                                    className="w-100 m-auto"
                                    onClick={() => history.push("/watches-list/MAURICE-LACROIX")}
                                    style={{ cursor: "pointer" }}
                                />
                                    :
                                    <Image
                                        src={BannerImg}
                                        alt="1975 Legacy Watch"
                                        fluid
                                        className="w-100 m-auto"
                                    />
                                }
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Featured Sections */}
                <div className="featured_watches">
                    <Container fluid>
                        <Row>
                            <Col sm={12} md={12} lg={12} className="p-0">


                                {/* { isMobile  ? */}
                                {/* <Slider {...settingsWatchTop}>
                                    {featured.map((item) => (
                                        <div className="watch_slider_inner">

                                            <div key={item.id} className="text-center">
                                                <img
                                                    src={item.img}
                                                    alt={item.name}
                                                    style={{ width: "100%", height: "auto", objectFit: "cover" }}
                                                />
                                                <p>{item.name}</p>
                                            </div>
                                        </div>
                                    ))}

                                </Slider> */}
                                {/* // : */}
                                <ul className=" justify-content-center align-items-center list-unstyled w-100">
                                    {featured.map((item) => (
                                        <li key={item.id} className="text-center">

                                            <div className="featured_watches_img_box">
                                                <img
                                                    src={item.img}
                                                    alt={item.title}
                                                    className="w-100 img-fluid"
                                                    onClick={() => history.push("/watches-list/MAURICE-LACROIX")}
                                                    style={{ cursor: "pointer" }}
                                                />
                                            </div>
                                            {/* <h5 className="mt-2">{item.title}</h5> */}
                                        </li>
                                    ))}
                                </ul>
                                {/* // } */}
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* Our Collections */}
                <div className="maurice_lacroix_collections_section">
                    <Container fluid>
                        <Row>
                            <Col sm={12} md={12} lg={12} className="p-0">
                                <div className="maurice_lacroix_watch_heading text-center">
                                    <h2>OUR COLLECTIONS</h2>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} md={12} lg={12} className="p-0">
                                <Slider {...settingsWatch}>
                                    {collections.map((item) => (
                                        <div className="watch_slider_inner">

                                            <div key={item.id} className="text-center">
                                                <img
                                                    src={item.img}
                                                    alt={item.name}
                                                    style={{ width: "100%", height: "auto", objectFit: "cover", cursor: "pointer" }}
                                                    onClick={() => history.push("/watches-list/MAURICE-LACROIX")}
                                                />
                                                <p onClick={() => history.push("/watches-list/MAURICE-LACROIX")} style={{ cursor: "pointer" }}>{item.name}</p>
                                            </div>
                                        </div>
                                    ))}

                                </Slider>
                            </Col>
                        </Row>
                    </Container>

                </div>
                {/* Manufacture Section */}
                <div className="manufacture_section py-5">
                    <Container fluid>
                        <Row>
                            <Col md={6}>
                                <div className="manufacture_img_box">
                                    <Image src={manufacture1} alt="Manufacture" fluid />
                                </div>
                            </Col>
                            <Col md={6} >
                                <div className="manufacture_content pl-lg-4">

                                    <h4>Our Manufacture</h4>
                                    <p>
                                        Maurice Lacroix watches are born in Switzerland, designed with
                                        creativity and built with precision. Each detail reflects a
                                        passion for horology.
                                    </p>
                                    <Button variant="dark" >Discover</Button>
                                </div>
                                <div md={12} className="text-md-left">
                                    <Image src={manufacture2} alt="Watch Movement" fluid />
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* Watch Straps Showcase */}
                <div className="watch-straps pt-3">
                    <Container fluid>
                        <Row>
                            <Col className="p-0">
                                <Image
                                    src={Bannerbottom}
                                    alt="Watch Straps Collection"
                                    fluid
                                    className="img-fluid"
                                />
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </div>
    )
}

export default MauriceLacroix

